/** `count` and `noun`, plural unless the count is one: "1 broker", "3 brokers". For nouns that take an "s". */
export function pluralize(count: number, noun: string): string {
    return `${count} ${noun}${count === 1 ? '' : 's'}`
}
